export default {
    idOrigen: null,
    idModelo: null,
    metaData: {
        nombreCliente: null,
        telefonoCliente: null,
        numeroAbonadoCliente: null,
        emailCliente: null,
        direccionCliente: null,
        cpCliente: null,
        poblacionCliente: null,
        imei: null,
        sn: null,
        fechaCompra: null,
        horarioContacto: null,
        dniCliente: null,
        dondeVenta: null,
    },
    albaran: {
        nombre: null,
        base64: null
    },
    linea: {
        sintomaAveria: null,
        observaciones: null
    },
}